import { render, staticRenderFns } from "./StoryItem.vue?vue&type=template&id=30dedd95"
import script from "./StoryItem.vue?vue&type=script&lang=ts"
export * from "./StoryItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports